import { useIsModifierAvailable } from 'src/modules/checkout/composables/sales-availability/modifiers/IsModifierAvailable'
import { computed, toValue } from 'vue'

// Options is a hash containing fields that can be used to validate modifier availability.
const DEFAULT_OPTIONS = Object.freeze({
  salesChannel: null,
  orderItem: null
})

// modifiers and options are optional, assuming the caller may intend to use computeAvailableModifiers directly
export function useAvailableModifiers (modifiers = [], options = DEFAULT_OPTIONS) {
  const { isModifierAvailable } = useIsModifierAvailable()

  function computeAvailableModifiers (modifiers, { salesChannel, orderItem } = DEFAULT_OPTIONS) {
    return _(toValue(modifiers))
      .filter(modifier => isModifierAvailable(modifier, { salesChannel, orderItem }).isAvailable)
      .sortBy('displayOrder')
      .value()
  }

  // We wrap modifiers with computed to ensure reactivity
  // useAvailableModifiers may be called with a null model, which wouldn't be reactive
  // e.g. props?.category?.modifiers?.data before category is set
  // This would prevent availableModifiers from reacting to changes in modifiers
  // If modifiers is set or already reactive, this is a safe no-op
  // This ensures useAvailableModifiers is resilient without complicated usage requirements
  const availableModifiers = computed(() => computeAvailableModifiers(computed(() => modifiers), options))

  return {
    computeAvailableModifiers,
    availableModifiers
  }
}
